import React from 'react';
import { useTranslation } from 'react-i18next';
import { apiZedocGetBenchmarkingToken } from '../../common/api/zedoc';
import useDocumentTitle from '../../utils/useDocumentTitle';
import Card from '../../components/Card';
import IframeEmbed from '../../components/patients/IframeEmbed';

const SettingsBenchmarking = () => {
  const { t } = useTranslation();

  useDocumentTitle([t('settings'), t('benchmarking')]);

  return (
    <Card>
      <IframeEmbed
        apiSpec={apiZedocGetBenchmarkingToken}
        params={{}}
        title={t('benchmarking')}
        toolName="benchmarking tool"
      />
    </Card>
  );
};

export default SettingsBenchmarking;
